import { bindActionCreators, PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

declare global {
  type fulfillDetailType = {
    progress: number;
    isOnFocus: boolean;
    writeName: string;
    fulfillCommentIdx: string;
    assessData: {
      score: number;
      star: any;
      comment: string;
    };
  };
}
const initialState: fulfillDetailType = {
  progress: 0,
  isOnFocus: false,
  writeName: "",
  fulfillCommentIdx: "",
  assessData: {
    score: 0,
    star: [false, false, false, false, false],
    comment: "",
  },
};

const fulfillDetailSlice = createSlice({
  name: "notice",
  initialState,
  reducers: {
    setOnFocusReduce: (state, action: PayloadAction<boolean>) => {
      state.isOnFocus = action.payload;
    },
    setAssessReduce: (state, action: PayloadAction<any>) => {
      state.assessData = action.payload;
    },
    setWriteNameReduce: (state, action: PayloadAction<Array<string>>) => {
      // state.writeName = action.payload;
      if (action.payload.length > 0) {
        state.writeName = action.payload[0];
        state.fulfillCommentIdx = action.payload[1];
      }
    },
  },
});

export const { setOnFocusReduce, setAssessReduce, setWriteNameReduce } = fulfillDetailSlice.actions;

export default fulfillDetailSlice.reducer;
